import assign = require('object-assign');
import { Promise } from 'es6-promise';

import { Node } from '../constants';
import { defaultFactory as request } from '../api/RequestFactory';
import FSA from './FSA';

import { INodeStates, fetchStates, toStateObject } from './NodeState';
import { INodeMeasurements, fetchMeasurements } from './NodeMeasurement';

interface INode {
    id: string;
    type: number;
}

function fetchNodes(requesterId: string, query): Promise<INode[]> {
    return request.post('me/query', query);
}

export function listNodes(requesterId: string, query): Function {
    return dispatch => {
        dispatch(new FSA(Node.FETCH_REQUEST).addMeta({ requesterId, query }).data);

        return fetchNodes(requesterId, query).then(nodes => {
            return dispatch(new FSA(Node.FETCH_SUCCESS).addPayload(nodes).addMeta({ requesterId, query }).data);
        }, err => {
            dispatch(new FSA(Node.FETCH_FAILURE).addError(err).addMeta({ requesterId, query }).data);
            throw err;
        });
    }
}

function getNodeIdsByType(nodes: INode[], type: number) {
    return nodes.filter(node => {
        return node.type === type;
    }).map((node) => {
        return node.id;
    });
}

export function listNodesWithStates(requesterId: string, nodeQuery, stateQuery) {
    return dispatch => {
        dispatch(new FSA(Node.FETCH_NODES_WITH_STATES_REQUEST).addMeta({ requesterId }).data);

        return fetchNodes(requesterId, nodeQuery).then((nodes: INode[]) => {
            const cId = getNodeIdsByType(nodes, 2);
            const aId = getNodeIdsByType(nodes, 3);
            const promises: Promise<INodeStates>[] = [];

            if (aId.length) {
                promises.push(
                    fetchStates(requesterId, "agent", assign({ aId }, stateQuery)).then((states: INodeStates[]) => {
                        return toStateObject(aId, states);
                    })
                );
            }

            if (cId.length) {
                promises.push(
                    fetchStates(requesterId, "container", assign({ cId }, stateQuery)).then((states: INodeStates[]) => {
                        return toStateObject(cId, states);
                    })
                );
            }

            if (!promises.length) {
                return dispatch(new FSA(Node.FETCH_NODES_WITH_STATES_SUCCESS).addPayload({ nodes, states: {} }).addMeta({ requesterId }).data);
            }

            return Promise.all(promises).then(results => {
                return results.reduce((merge: INodeStates, result: INodeStates) => {
                    return assign(merge, result);
                }, {});
            }).then((states: INodeStates) => {
                return dispatch(new FSA(Node.FETCH_NODES_WITH_STATES_SUCCESS).addPayload({ nodes, states }).addMeta({ requesterId }).data);
            });
        }).catch(err => {
            dispatch(new FSA(Node.FETCH_NODES_WITH_STATES_FAILURE).addError(err).addMeta({ requesterId }).data);
        });
    }
}

export function listNodesWithMeasurements(requesterId: string, nodeQuery, measurementQuery) {
    return dispatch => {
        dispatch(new FSA(Node.FETCH_NODES_WITH_MEASUREMENTS_REQUEST).addMeta({ requesterId }).data);

        return fetchNodes(requesterId, nodeQuery).then((nodes: INode[]) => {
            let promises: Promise<INodeMeasurements>[];
            const aIds = getNodeIdsByType(nodes, 3);
            const measurementsByAId = {};

            if (aIds.length) {
                promises = aIds.map((aId: string) => {
                    return fetchMeasurements(requesterId, assign({ aId }, measurementQuery)).then((measurements: INodeMeasurements[]) => {
                        return assign(measurementsByAId, { [aId]: measurements });
                    });
                });
            } else {
                return dispatch(new FSA(Node.FETCH_NODES_WITH_MEASUREMENTS_SUCCESS).addPayload({ nodes, measurements: {} }).addMeta({ requesterId }).data);
            }

            return Promise.all(promises).then(() => {
                return dispatch(new FSA(Node.FETCH_NODES_WITH_MEASUREMENTS_SUCCESS).addPayload({ nodes, measurements: measurementsByAId }).addMeta({ requesterId }).data);
            });
        }).catch(err => {
            dispatch(new FSA(Node.FETCH_NODES_WITH_MEASUREMENTS_FAILURE).addError(err).addMeta({ requesterId }).data);
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/Node.ts